// extracted by mini-css-extract-plugin
export default {"Snineth":"Snineth_Snineth__udkyq","wrap":"Snineth_wrap__LCjNC","text":"Snineth_text__oiGkD","title":"Snineth_title__CK5Nq","desc":"Snineth_desc__FZVCj"};